import { api } from '../utils/api'

export function fetchAccountOverview(options?: {
  cacheBust?: boolean
  syncBilling?: boolean
  quiet?: boolean
  signal?: AbortSignal
}) {
  return api.get('/account/overview', {
    params: {
      ...(options?.cacheBust ? { t: Date.now() } : {}),
      ...(options?.syncBilling ? { syncBilling: '1' } : {}),
    },
    headers: options?.cacheBust
      ? {
          'X-Client-No-Dedupe': true,
        }
      : undefined,
    signal: options?.signal,
  })
}

export function postRecalculateUsage() {
  return api.post('/organization/recalculate-usage')
}

export function patchOrganizationSettings(payload: Record<string, unknown>) {
  return api.patch('/organization/settings', payload)
}

export function fetchOrganizationInfo() {
  return api.get('/organization/info')
}

export function deleteOrganization(data: { password: string; confirmName: string }) {
  return api.delete('/organization', { data })
}
